import { render, staticRenderFns } from "./DataCellImage.vue?vue&type=template&id=a683f474&"
import script from "./DataCellImage.vue?vue&type=script&lang=js&"
export * from "./DataCellImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/normacs_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports